export const createSpriteSheet = (spriteSvg) =>
    fetch(spriteSvg)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((svg) => {
            const div = document.createElement("div");
            div.innerHTML = svg;
            Object.assign(div.style, {
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
            });
            document.body.appendChild(div);
        });
